import useApi from '../../common/hooks/useApi'
import useSWR from 'swr'
import { type Country } from '@amici/myamici-api-client'

interface UseCountryHook {
  countries: Country[] | undefined
  isLoading: boolean
  hasData: boolean
  loadingError: any
}

function useCountries (): UseCountryHook {
  const { metadataApi, fetcherWithoutParams } = useApi()

  const {
    data,
    isLoading,
    error: loadingError
  } = useSWR(
    'allCountries',
    async () => await fetcherWithoutParams(metadataApi.getAllCountries())
  )

  const hasData = Array.isArray(data) && data.length > 0

  return {
    countries: data,
    isLoading,
    hasData,
    loadingError
  }
}

export default useCountries
